import React from 'react';
import SettlementRateComponent from "./SettlementRateComponent";

const setSettlementRateBands = (SettlementRateBands, caseRuleTypeId) => {
	if(!caseRuleTypeId || caseRuleTypeId !== 3)
		return SettlementRateBands;
	let newSettlementRateBands = [];
	if(caseRuleTypeId && caseRuleTypeId === 3){
		newSettlementRateBands[0] = {};
		newSettlementRateBands[0].settlementRateBandCaseCount = 13;
		newSettlementRateBands[0].settlementRateBandLabel = "";
		newSettlementRateBands[0].settlementRateValue = .1013;
	}
	return newSettlementRateBands;
	
};

const SettlementRateContainer = (props) => {

	return (
		<React.Fragment>
			<SettlementRateComponent currentSettlementRateBands={setSettlementRateBands(props.currentSettlementRateBands,props.caseRuleTypeId)} caseRuleTypeId={props.caseRuleTypeId} /> 
		</React.Fragment>
	);

};


export default SettlementRateContainer;



// WEBPACK FOOTER //
// ./src/common/components/SettlementRate/SettlementRateContainer.js